import { databaseFiltersName } from 'utils/consts'
import type { FiltersCollection } from '../filtersCollectionsRegistry'
import type { DatabaseFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import { pickEntries } from './entries'

type Role = string

export const getDatabaseSpecClasConditionFiltersCollection = (
  _role: Role
): FiltersCollection =>
  pickEntries([
    databaseFiltersName.specialClassificationFilter,
    databaseFiltersName.countryFilter,
    databaseFiltersName.nationalGITypeFilter,
    databaseFiltersName.geoIndicationFilter,
    databaseFiltersName.wineTypeFilter,
    databaseFiltersName.wineColourFilter,
    databaseFiltersName.sweetnessTypeFilter,
  ])

export const databaseSpecClasConditionFiltersConfig: DatabaseFiltersConfig = {
  component: 'database',
  getFiltersCollection: getDatabaseSpecClasConditionFiltersCollection,
  showResultsTextKey: 'filters.button.apply',
}
